import { Outlet, useLocation } from "react-router-dom";
import { TopBar } from "./TopBar";
import { BottomNav } from "./BottomNav";
import { Sidebar } from "./Sidebar";
import { useUIStore } from "@/stores/useUIStore";
import { cn } from "@/lib/utils";
import { isFullHeightRoute } from "./fullHeightRoutes";
import { usePresenceHeartbeat } from "@/hooks/usePresenceHeartbeat";

function AppShell() {
  const { sidebarOpen, sidebarWidth } = useUIStore();
  const { pathname } = useLocation();
  const isFullHeight = isFullHeightRoute(pathname);
  // "Active now" on org member lists; best effort, never blocks the shell.
  usePresenceHeartbeat();

  return (
    <div
      className={cn("bg-surface-secondary", isFullHeight ? "h-dvh overflow-hidden" : "min-h-screen")}
      style={{ ["--sidebar-w" as string]: `${sidebarWidth}px` }}
    >
      <Sidebar />
      <div
        className={cn(
          "flex flex-col",
          isFullHeight ? "h-dvh" : "min-h-screen",
          "md:ml-16",
          sidebarOpen && "md:ml-[var(--sidebar-w)]",
        )}
      >
        <TopBar />
        {/* md:pb-28 keeps the last element of a page clear of the toast band
            (bottom-4 + toast height). Desktop previously had pb-0, so page
            content ended flush against the viewport bottom and a toast landed
            straight on top of it. Mobile's pb-nav-safe clears BottomNav, and
            the toast is raised above that nav rather than padded around.

            A full-height route drops the desktop toast padding: its page is
            already exactly the leftover viewport, so padding it from out here
            can only push it past the bottom edge. Mobile keeps nav
            clearance because BottomNav is a fixed overlay that would otherwise
            sit on top of the composer, but exactly the nav's height
            (pb-nav-exact): pb-nav-safe's extra rem showed as a dead band
            under the composer. min-h-0 lets the page shrink to the
            flex track instead of being floored at its content height. */}
        <main
          className={cn(
            "flex-1",
            isFullHeight ? "min-h-0 pb-nav-exact md:pb-0" : "pb-nav-safe md:pb-28",
          )}
        >
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}

export { AppShell };
